import { ApiCrudObjectControllerBindings, WorkerAccountCrudController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * LEGACY: Shows a view of a single worker account, which may have one or several Employments Relations.
 * This used to be the main way of viewing and editing Worker AND Employment details, but now the Employment view is used instead.
 * @deprecated Use EmploymentDetails instead.
 */
export class WorkerDetails extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = new ApiCrudObjectControllerBindings();

    /** Uses the WorkerAccountCrudController */
    public controller = WorkerAccountCrudController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/worker/WorkerDetails.html";

}
